export default {
  title: 'Secret de semnare webhook',
  warning:
    'Salvează acest secret acum — nu va mai fi afișat din nou. Folosește-l pentru a verifica header-ul X-Webhook-Signature.',
  done: 'Gata',
};
